import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useSiteUrls } from '../../api';
import styles from './SitePreviewPreview.scss';
import { BrowserFrame } from '@wix/gg-common-lib/components';
import { SkeletonGroup, SkeletonRectangle } from '@wix/design-system';

export function SitePreviewPreview() {
  const { t } = useTranslation();
  const { data: siteUrl, isLoading } = useSiteUrls();

  return (
    <div className={styles.container}>
      <BrowserFrame headerProps={{ url: siteUrl }}>
        {isLoading || !siteUrl ? (
          <SkeletonGroup>
            <SkeletonRectangle width="100%" height="9999px" />
          </SkeletonGroup>
        ) : (
          <iframe src={siteUrl} title={t('site_preview.preview.title')} className={styles.iframe} />
        )}
      </BrowserFrame>
    </div>
  );
}
